import { fromNullable } from 'maybeasy';
import { observer } from 'mobx-react';
import { emptyFragment } from '../../../../../../EmptyFragment';
import ModalStore from '../../../../../Modal/Store';
import LearningCollectionEditStore from '../../../Edit/Store';
import BrowseAll from './BrowseAll';
import ProjectFeedback from './ProjectFeedback';

interface Props {
  store: LearningCollectionEditStore;
  execonlineCatalogModalStore: ModalStore;
  videoProjectFeedbackModalStore: ModalStore;
  warnUser: () => boolean;
}

function LegacyAddOns({
  store,
  execonlineCatalogModalStore,
  videoProjectFeedbackModalStore,
  warnUser,
}: Props) {
  switch (store.state.kind) {
    case 'waiting':
    case 'loading':
    case 'load-error':
    case 'loading-for-deep-links':
    case 'ready-deep-links':
    case 'loading-for-invitations':
    case 'ready-invitations':
      return emptyFragment();
    case 'ready':
    case 'editing-details':
    case 'saving-details':
    case 'building':
    case 'choosing-learning-designs':
    case 'adding-learning-design':
    case 'deleting-section':
    case 'previewing':
    case 'sharing':
    case 'finishing':
    case 'finished':
    case 'updating':
    case 'edit-form-submission-error':
    case 'previewing-updating':
    case 'updating-product-license':
      return fromNullable(
        store.state.learningCollectionEditFormResource.templates[
          'create-browse-all-learning-design'
        ],
      )
        .map(emptyFragment)
        .getOrElse(() => (
          <>
            <ProjectFeedback
              store={store}
              videoProjectFeedbackModalStore={videoProjectFeedbackModalStore}
            />
            <BrowseAll
              store={store}
              execonlineCatalogModalStore={execonlineCatalogModalStore}
              warnUser={warnUser}
            />
          </>
        ));
  }
}

export default observer(LegacyAddOns);
